import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box/Box';

export const WrapperStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '24px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: 'auto',
  flexShrink: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const ActionsStyled = styled(Box)<{ fullWidth?: boolean }>(({ fullWidth }) => ({
  gap: '8px',
  width: '100%',
  alignItems: 'center',
  display: 'grid',
  gridTemplateColumns: fullWidth ? '1fr' : '1fr 1fr',
}));
